import { ModelMarker } from '../../model/services/state';
import { Named } from '../../model/base/named';

export function markProxy(entity: Named): void {
    ModelMarker.markProxy(entity);
}

export function markZombie(entity: Named): void {
    ModelMarker.markZombie(entity);
}

export function markListed(entity: Named): void {
    ModelMarker.markListed(entity);
}

export function markBroken(entity: Named): void {
    ModelMarker.markBroken(entity);
}

export function markNew(entity: Named): void {
    ModelMarker.markNew(entity);
}
